module.exports = __webpack_public_path__ + "img/beex-dark-small.de164b6d.svg";